import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GdprNoticeState } from './gdprNotice.reducer';

const selectGdprNoticeState = createFeatureSelector<GdprNoticeState>('gdprNotice');

export const selectValidationSuccess = createSelector(
  selectGdprNoticeState,
  state => state.checkToken.data
);

export const selectValidationError = createSelector(
  selectGdprNoticeState,
  state => state.checkToken.error
);

export const selectOptOutSuccess = createSelector(
  selectGdprNoticeState,
  (state: GdprNoticeState) => state.optOut.data
);

export const selectOptOutError = createSelector(
  selectGdprNoticeState,
  (state: GdprNoticeState) => state.optOut.error
);
